// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/** 缓存数据的 class */
class Storage {
    // 缓存数据的对象
    _data = {};

    /**
     * 检测是否存在指定的 key 值
     * @param {string} key 检测的 key 值
     * @returns {boolean} 返回布尔值, true 表示存在, false 表示不存在
     */
    has(key) {
        return !!this.get(key);
    }

    /**
     * 设置存储数据的方法
     * @param {string} key 需要设置的 key 值
     * @param {any} value 设置指定的 key 的数据
     */
    set(key, value) {
        try {
            uni.setStorageSync(key, value);
            this._data[key] = value;
            return true;
        } catch (e) {
            return false;
        }
    }

    /**
     * 获取数据的方法
     * @param {string} key 指定 key 值获取数据
     * @returns {any} 返回数据
     */
    get(key) {
        if (this._data[key]) {
            return this._data[key];
        }
        try {
            this._data[key] = uni.getStorageSync(key);
            return this._data[key];
        } catch (e) {
            return null;
        }
    }

    /**
     * 删除指定 key 的数据的方法
     * @param {string} key 删除指定 key 对应的数据
     * @returns {boolean} 返回布尔值, true 表示删除成功, false 表示删除失败
     */
    del(key) {
        try {
            uni.removeStorageSync(key);
            delete this._data[key];
            return true;
        } catch (e) {
            return false;
        }
    }

    /** 清除所有数据的方法 */
    clear() {
        try {
            uni.clearStorageSync();
            this._data = {};
            return true;
        } catch (e) {
            return false;
        }
    }
}

export default new Storage();
